const svgSplash = `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="1920.000000pt" height="1080.000000pt" viewBox="0 0 1920.000000 1080.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M0 5400 l0 -5400 5983 2 c4779 2 5981 6 5980 16 -2 6 3 12 10 13 59
2 108 12 142 29 23 11 60 20 84 20 23 0 76 11 116 25 41 13 81 22 90 19 9 -4
23 1 33 9 9 8 31 19 47 23 17 3 37 12 45 19 8 7 48 19 88 26 42 7 76 18 79 26
3 7 19 13 37 13 17 0 45 7 61 16 27 14 98 32 148 38 9 1 23 8 29 14 7 7 17 12
24 12 6 0 47 12 90 26 44 14 92 27 108 30 35 4 86 26 86 36 0 5 14 8 30 8 17
0 50 9 73 21 64 31 137 57 187 64 25 4 54 14 65 21 11 8 29 14 41 14 12 0 32
9 46 20 14 10 49 28 77 40 29 11 80 38 113 61 33 22 75 46 92 55 42 19 135 74
172 100 16 12 43 29 61 37 17 9 37 22 45 30 7 7 46 35 85 61 40 27 78 55 84
62 6 8 16 14 21 14 6 0 23 10 38 23 15 12 41 32 57 44 40 31 93 84 93 94 0 4
8 10 18 13 29 10 181 164 247 251 112 148 266 397 326 525 41 88 49 109 49
121 0 11 2 11 11 -1 8 -11 9 -8 4 15 -4 16 -3 27 1 22 7 -7 40 63 49 105 2 10
14 45 26 78 23 63 39 77 21 18 -104 -338 -178 -531 -288 -749 -166 -333 -335
-570 -579 -815 -218 -220 -452 -390 -725 -529 -179 -90 -235 -114 -430 -181
l-155 -53 2983 0 2982 -1 0 5400 0 5400 -4819 0 -4818 0 3 -182 c2 -101 6
-235 8 -298 6 -185 -12 -885 -29 -1145 -29 -448 -76 -863 -140 -1245 -202
-1200 -634 -2318 -1252 -3235 -188 -279 -291 -417 -305 -409 -7 4 -8 2 -4 -4
9 -15 -43 -84 -57 -75 -6 3 -7 1 -3 -5 7 -12 -23 -54 -34 -47 -4 3 -18 -7 -30
-20 -13 -14 -20 -25 -16 -25 4 0 17 10 28 22 11 13 16 16 12 8 -13 -28 -47
-59 -57 -53 -6 4 -8 0 -5 -9 4 -8 -1 -22 -10 -30 -10 -8 -34 -34 -55 -57 -21
-23 -43 -38 -49 -35 -7 5 -8 2 -3 -5 9 -16 -130 -153 -180 -176 -19 -10 -35
-22 -35 -28 0 -5 10 -2 23 9 l22 18 -22 -24 c-22 -24 -23 -24 -37 -5 -15 20
-15 20 -38 -4 -13 -13 -17 -20 -9 -16 8 4 17 2 23 -6 7 -10 7 -7 3 9 -7 25 10
30 19 5 7 -17 -11 -35 -29 -30 -5 2 -26 -12 -45 -31 l-35 -34 40 28 c31 21 27
15 -20 -29 -33 -31 -64 -56 -69 -57 -6 0 -1 6 9 14 23 17 28 56 6 56 -12 0
-12 3 -3 12 10 10 14 10 21 0 6 -10 10 -10 21 3 7 8 10 18 6 22 -3 3 -6 1 -6
-5 0 -7 -4 -12 -9 -12 -5 0 -7 9 -4 20 3 11 0 20 -6 20 -6 0 -11 -7 -11 -15 0
-8 -5 -15 -12 -15 -6 0 -20 -7 -30 -17 -10 -9 -21 -13 -25 -10 -9 10 27 47 45
47 12 0 12 4 -3 20 -23 26 -35 25 -35 -1 0 -11 -4 -17 -10 -14 -6 3 -10 -5
-10 -18 0 -26 -16 -37 -56 -37 -15 0 -24 6 -24 15 0 9 9 15 25 15 22 0 25 4
25 40 0 34 7 47 55 96 34 36 55 66 55 81 0 14 6 23 15 23 8 0 22 18 31 40 9
22 20 40 25 40 5 0 9 6 9 14 0 7 18 33 40 57 22 24 40 54 40 66 0 12 18 40 40
63 21 22 37 40 34 40 -3 0 4 12 15 26 12 15 21 31 21 36 0 6 11 19 25 30 14
11 25 30 25 44 0 13 4 24 9 24 5 0 16 17 24 39 9 21 23 41 31 44 9 4 16 13 16
22 0 21 47 95 65 102 18 6 20 30 3 36 -9 3 -4 14 13 33 15 16 37 49 49 74 13
25 26 47 30 50 4 3 20 29 35 59 15 30 35 62 44 70 10 9 28 41 41 71 13 30 34
66 47 81 13 14 23 32 23 41 0 20 32 78 43 78 4 0 7 6 7 14 0 7 6 19 14 25 8 7
18 25 21 41 3 15 15 36 26 46 10 9 19 27 19 39 0 13 6 28 14 34 8 7 18 25 21
41 3 15 15 36 26 46 10 9 19 28 19 41 0 12 4 23 9 23 4 0 16 20 25 44 9 25 24
50 32 56 7 7 14 22 14 34 0 12 9 27 19 33 11 7 22 26 26 43 4 16 10 28 15 25
5 -3 11 8 15 25 4 16 10 30 14 30 4 0 13 17 20 38 26 73 42 101 57 95 10 -3
14 2 14 18 0 27 28 107 45 129 7 8 24 42 39 75 15 33 43 94 63 135 33 68 52
110 88 195 8 17 24 55 37 85 29 65 41 97 80 210 16 47 35 99 42 115 24 57 35
90 42 135 3 24 13 49 20 55 8 5 16 28 18 50 8 67 14 92 25 113 6 11 12 33 14
49 2 15 9 38 15 50 7 12 12 35 12 52 0 16 5 33 10 36 6 3 10 23 11 43 1 38 16
99 18 73 3 -47 28 52 35 139 1 19 8 45 15 58 6 12 9 26 6 31 -3 5 2 40 10 78
9 37 18 91 21 118 3 28 12 75 20 106 8 31 14 70 14 86 0 16 4 33 9 38 5 6 19
95 30 198 12 104 26 199 31 213 6 14 10 48 10 75 0 28 4 69 9 92 21 95 32 204
36 334 5 181 13 284 29 358 8 33 12 87 11 120 -2 33 1 65 5 70 15 20 20 66 21
177 0 62 4 115 9 118 5 3 10 53 11 110 1 58 6 108 12 111 14 9 29 83 34 169 3
41 8 80 13 85 5 6 12 38 16 73 3 34 11 62 16 62 6 0 8 7 4 15 -3 8 -2 15 2 15
4 0 8 15 9 33 4 58 14 98 24 92 5 -4 9 3 9 14 l0 21 -4735 0 -4735 0 0 -5400z
m14757 1180 c-52 -33 -98 -60 -102 -60 -4 0 11 15 34 34 22 18 37 37 33 40 -3
4 0 5 8 1 8 -3 35 6 60 19 82 45 65 27 -33 -34z m-320 -352 c-3 -8 -6 -5 -6 6
-1 11 2 17 5 13 3 -3 4 -12 1 -19z m-10 -40 c-3 -8 -6 -5 -6 6 -1 11 2 17 5
13 3 -3 4 -12 1 -19z m-22 -144 c-21 -164 -23 -178 -52 -268 -70 -226 -203
-395 -522 -665 -232 -198 -276 -242 -345 -345 -174 -261 -412 -448 -686 -539
-162 -53 -228 -62 -470 -62 -207 1 -236 3 -355 28 -181 39 -380 107 -542 187
-233 114 -222 105 -678 535 -279 264 -280 265 -374 328 -29 21 -46 37 -38 37
9 0 19 -4 22 -10 3 -5 11 -10 16 -10 6 0 7 6 3 13 -6 9 -4 9 8 -1 11 -9 23
-10 42 -2 39 14 46 11 11 -5 -19 -9 -24 -14 -12 -15 9 0 17 -4 17 -10 0 -5 5
-10 11 -10 8 0 8 4 -1 15 -10 12 -6 14 24 11 20 -2 39 -6 43 -10 3 -3 18 -6
32 -6 14 0 39 -11 55 -25 17 -14 36 -23 43 -21 7 3 17 -4 23 -15 6 -11 16 -18
23 -17 7 2 26 -7 44 -20 17 -12 36 -22 42 -22 6 0 11 -4 11 -9 0 -4 25 -19 55
-32 30 -13 55 -27 55 -31 0 -5 6 -8 14 -8 8 0 21 -6 28 -12 7 -7 28 -21 46
-31 18 -10 43 -28 55 -40 14 -14 91 -45 202 -82 99 -32 182 -63 183 -67 2 -4
13 -8 25 -8 12 0 45 -9 74 -20 29 -11 59 -17 67 -14 8 3 36 -4 63 -16 26 -12
64 -22 83 -22 19 0 69 -8 110 -19 71 -18 126 -28 280 -51 36 -5 148 -12 250
-15 264 -7 372 7 570 74 71 24 194 84 203 99 4 8 15 14 22 14 8 0 15 4 15 9 0
5 8 12 18 15 36 14 62 31 62 41 0 6 17 19 37 30 38 20 123 99 123 114 0 4 11
14 25 21 13 7 28 23 31 34 4 12 15 28 25 37 11 9 19 20 19 24 0 4 10 20 23 35
12 15 31 40 41 56 28 42 263 274 277 274 7 0 9 3 6 6 -4 4 13 21 36 39 23 18
54 45 69 61 15 16 63 65 107 109 45 44 81 85 81 91 0 6 10 20 23 31 42 39 87
100 116 158 6 11 26 38 45 59 19 22 38 53 42 69 13 62 13 15 -1 -99z m-4088
-738 c0 -8 -6 -12 -15 -9 -11 5 -11 7 0 14 7 5 13 9 14 9 0 0 1 -6 1 -14z
m-3170 -1729 c-8 -7 -17 -19 -20 -27 -3 -8 -5 -4 -4 11 1 17 7 26 20 26 17 2
17 0 4 -10z m-72 -83 c-27 -23 -77 -54 -65 -41 13 14 83 67 89 67 3 -1 -7 -12
-24 -26z m-75 -60 c0 -1 -12 -10 -27 -20 -20 -13 -25 -13 -16 -2 7 8 11 17 8
19 -2 3 5 5 15 5 11 0 20 -1 20 -2z m-100 -79 c-7 -8 -17 -15 -23 -15 -6 0 -2
7 9 15 25 19 30 19 14 0z m8547 -897 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3
4 -12 1 -19z m-10 -40 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z"/>
<path d="M7624 4028 l-19 -23 23 19 c12 11 22 21 22 23 0 8 -8 2 -26 -19z"/>
<path d="M7583 3983 c0 -9 4 -10 14 -2 7 6 13 12 13 14 0 1 -6 2 -13 2 -8 0
-14 -6 -14 -14z"/>
<path d="M7523 3923 c0 -10 4 -10 16 -1 9 7 18 13 20 15 2 1 -5 1 -16 0 -11 0
-20 -7 -20 -14z"/>
<path d="M7440 3842 c0 -6 -6 -9 -13 -6 -19 7 -43 -24 -30 -37 8 -8 11 -6 10
6 -1 10 4 20 12 23 9 3 11 0 6 -9 -4 -8 0 -6 10 3 11 10 16 21 12 24 -4 4 -7
2 -7 -4z"/>
<path d="M7210 3629 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
</g>
</svg>
`;

export default svgSplash;